export const formFields = [
  {
    label: 'Vendor',
    key: 'vendorName',
    isRequired: true,
  },
  {
    label: 'Contact Name',
    key: 'contactName',
    isRequired: true,
  },
  {
    label: 'Email',
    key: 'email',
    type: 'email',
    isRequired: true,
  },
  {
    label: 'Phone',
    key: 'phone',
    isRequired: true,
  },
];
